// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1o2Xy","footer":"ModalUpdate_footer__2sCwH"};